import Vue from "vue";
import App from "./App.vue";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import store from "./store/store.js";
import router from "./router";
import moment from "moment";
import axios from "axios";
import vSelect from 'vue-select'
Vue.component('v-select', vSelect);
import 'vue-select/dist/vue-select.css';

import "./assets/css/main.css";

import C from "@/c";

import firebase from '@/firebase/firebaseInit';
const auth = firebase.auth;
const db = firebase.db;

Vue.config.productionTip = false;
Vue.use(BootstrapVue, axios);
Vue.prototype.$moment = moment;
Vue.prototype.$C = C;

auth.onAuthStateChanged(() => {
  db;
  // if (!app) {
  new Vue({
    store,
    router,
    render: (h) => h(App),
  }).$mount("#app");
  // }
});
